import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { DELETE_DOCUMENT_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class DeleteDocument extends BaseApiRequest {
  method = METHOD.HTTP.DELETE;

  body = {};

  url = DELETE_DOCUMENT_URL;

  constructor(applicationId, documentId) {
    super();
    const paramList = [applicationId, documentId];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
